import React from "react";
import styles from "assets/jss/material-dashboard-react/components/tablebaocaoStyle.js";
const useStyles = makeStyles(styles);
import { makeStyles } from "@material-ui/core/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import FormControl from "@mui/material/FormControl";
import Phulucduongsattable from "components/Tonghopvantai/Phulucduongsattable.js";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import dayjs from "dayjs";

export default function Phulucduongsat() {
  const classes = useStyles();
  const [thangnam, setThangnam] = React.useState(dayjs());
  return (
    <GridContainer>
      <GridItem xs={12} sm={10} md={12} style={{ marginTop: 5 }}>
        <FormControl style={{ width: "15%" }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Chọn tháng năm"
              value={thangnam}
              onChange={(newValue) => {
                setThangnam(newValue);
              }}
              format="MM/YYYY"
              slotProps={{ textField: { size: "small" } }}
              views={["month", "year"]}
              sx={{
                "& .MuiInputBase-root": {
                  height: "27px",
                },
              }}
            />
          </LocalizationProvider>
        </FormControl>
        <FormControl style={{ width: "8%", marginLeft: 10, height: "30px" }}>
          <ReactHTMLTableToExcel
            id="test-table-xls-button"
            className={classes.button}
            table="phulucduongsat"
            filename="phulucduongsat"
            sheet="phulucduongsat"
            buttonText="Tải file"
          />
        </FormControl>
      </GridItem>
      <GridItem xs={12} sm={10} md={12} style={{ marginTop: 5 }}>
        <Phulucduongsattable thangnam={thangnam} />
      </GridItem>
    </GridContainer>
  );
}
